import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function RoundIndeterminateCheckboxIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_2950_54766)'>
        <rect
          width='16'
          height='16'
          rx='4'
          fill={props.fill ?? '#3E8FFA'}
        />
        <g clipPath='url(#clip1_2950_54766)'>
          <path
            d='M12.666 8.66732H3.33268C3.15587 8.66732 2.9863 8.59708 2.86128 8.47206C2.73625 8.34703 2.66602 8.17746 2.66602 8.00065C2.66602 7.82384 2.73625 7.65427 2.86128 7.52925C2.9863 7.40422 3.15587 7.33398 3.33268 7.33398H12.666C12.8428 7.33398 13.0124 7.40422 13.1374 7.52925C13.2624 7.65427 13.3327 7.82384 13.3327 8.00065C13.3327 8.17746 13.2624 8.34703 13.1374 8.47206C13.0124 8.59708 12.8428 8.66732 12.666 8.66732Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2950_54766'>
          <rect
            width='16'
            height='16'
            rx='4'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip1_2950_54766'>
          <rect
            width='16'
            height='16'
            fill='white'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
